import { YStack } from 'tamagui';
import { MessageBubble } from './MessageBubble';
import type { ThreadMessage } from '../../lib/chat-hooks';

/** Renders the thread oldest-first. */
export function MessageList({ messages }: { messages: ThreadMessage[] }) {
  return (
    <YStack gap="$3" flex={1}>
      {messages.map((message) => (
        <MessageBubble key={message.id} message={message} />
      ))}
    </YStack>
  );
}
